import { HttpInterceptorFn } from '@angular/common/http'
import { inject } from '@angular/core'
import { Router } from '@angular/router'
import { catchError, finalize, throwError } from 'rxjs'
import { AuthService } from '../services/auth.service'
import { SKIP_AUTH } from '../interceptors/skip-auth.interceptor-context'
import { LoaderService } from '../services/loader.service'
import { SKIP_LOADER } from '../services/skip-loader.token'

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService)
  const loaderService = inject(LoaderService)
  const router = inject(Router)

  const skipLoader = req.context.get(SKIP_LOADER)

  if (!skipLoader) {
    loaderService.show()
  }

  // If request should skip auth
  if (req.context.get(SKIP_AUTH)) {
    return next(req).pipe(finalize(() => loaderService.hide()))
  }
  const skipAuth = req.context.get(SKIP_AUTH)
  const token = authService.getToken()

  // Clone request with Authorization header if token exists
  if (token && !skipAuth) {
    const authReq = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    })

    return next(authReq).pipe(
      catchError((error) => {
        // Only 401 (missing/expired/invalid token) ends the session. A 403 means the
        // user is authenticated but not permitted for that resource — surface the error
        // to the caller instead of logging them out (e.g. a manager hitting an
        // Admin-only endpoint should not be force-logged-out).
        if (error.status === 401) {
          authService.logout()
          window.location.href = '/login'
        }
        return throwError(() => error)
      }),
      finalize(() => {
        if (!skipLoader) {
          loaderService.hide()
        }
      })
    )
  }
  return next(req).pipe(
    finalize(() => {
      if (!skipLoader) {
        loaderService.hide()
      }
    })
  )
}
